module.exports = __webpack_public_path__ + "img/left_2.62f7b931.jpg";